import type { NotificationConfig } from 'bundles/ai-coach-platform/components/patterns/chat/notifications/types';
import { ResolutionStatus } from 'bundles/ai-coach-platform/components/patterns/suggestions/types';
import localStorageEx from 'bundles/common/utils/localStorageEx';

import _t from 'i18n!nls/ai-coach-platform';

export const COACH_CHAT_CONTINUOUS_CHAT_NOTIFICATION_DISMISSED =
  'AiCoachPlatform_NewContinuousChatFeatureNotificationDismissed';

const isNotificationDismissed = (): boolean | null => {
  return localStorageEx.getItem<boolean>(
    COACH_CHAT_CONTINUOUS_CHAT_NOTIFICATION_DISMISSED,
    (value) => value === 'true',
    false
  );
};

const setNotificationDismissed = () => {
  localStorageEx.setItem(COACH_CHAT_CONTINUOUS_CHAT_NOTIFICATION_DISMISSED, true, () => 'true');
};

// helper to check if a user has never interacted with Coach before
const isNewCoachUser = (): boolean => {
  // any count other than 0 means users have interacted with Coach already.
  const messageCount = localStorageEx.getItem<number>('coach-chat-message-count-pendo', (value) => Number(value), 0);
  // this is the older key we used, defaults to 0 if not set
  const messageCountOld = localStorageEx.getItem<number>('coach-message-count-pendo', (value) => Number(value), 0);

  const isNewUser = messageCount === 0 && messageCountOld === 0;

  const isContinuousChatNotificationDismissed = isNotificationDismissed();

  // If messageCount is 0 and messageOldCount is 0, we need to set the chat notification as dismissed in localStorage so that we never show the notification even after a user sends a message to Coach
  if (isNewUser && !isContinuousChatNotificationDismissed) {
    setNotificationDismissed();
  }

  return isNewUser;
};

export const getContinuousChatNotificationConfig = (): NotificationConfig => ({
  id: 'continuous-chat-notification',
  status: ResolutionStatus.UNRESOLVED,
  title: _t('New! Resume your Coursera AI Chat conversation'),
  content: _t('Coursera AI Chat remembers your conversation so you can pick up where you left off.'),
  acceptLabel: _t('Got it'),
  hideDismiss: true,
  onAction: setNotificationDismissed,
  onMount: () => {},
  // don't show this notification if the user has dismissed it OR
  // never interacted with Coach (only meant to show for existing users)
  isDismissed: isNotificationDismissed() || isNewCoachUser(),
});
